import React from 'react';
import { render } from 'react-dom';
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.js';
require('dotenv').config()

render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<App />} />
            {/* <Route path="/buy" element={<Buy />} />
            <Route path="/about" element={<About />} /> */}
        </Routes>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
